import { useState, useRef } from 'react';
import { StyledButton, StyledInput } from '../StyledComponents';
import ReCAPTCHA from 'react-google-recaptcha'
import Loading from '../Loading'
import Snackbar from '../Snackbar';

import '../../styles/ValidateData.css';

const server = process.env.REACT_APP_OCR_de_OC_API_URL;

const ValidateData = ({ setView }) => {
  const [loading, setLoading] = useState(false);
  const [snackbarText, setSnackbarText] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [mailToValidate, setMailToValidate] = useState("");

  const recaptcha = useRef();

  const validate = async () => {
    setLoading(true);
    if (!captchaValue) {
      setCaptchaValue(null)
      setLoading(false);
      setSnackbarText("Por favor, valida el reCAPTCHA!");
      setOpenSnackbar(true);
    } else {
      try {
        const response = await fetch(`${server}/validateMail`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ mailToValidate })
        });
        if(response.ok) {
          const responseData = await response.json();
          if (responseData.validated) {
            setCaptchaValue(null)
            setView("s");
            setView("UploadFile");
          } else {
            setCaptchaValue(null)
            setLoading(false);
            setSnackbarText("No tiene permitido el acceso a esta herramienta");
            setOpenSnackbar(true);
          }
          setLoading(false);
        } else {
          setCaptchaValue(null)
          setLoading(false);
          setSnackbarText("No tiene permitido el acceso a esta herramienta");
          setOpenSnackbar(true);
        }
      } catch (error) {
        setCaptchaValue(null)
        setLoading(false);
        console.error('Error en la conexión con el servidor', error.message);
        setSnackbarText("Hubo un error con la conexión al servidor");
        setOpenSnackbar(true);
      }
    }
    setLoading(false);
  };

  return (
    <div>
      { loading === true ? (
        <div className="loadingInitialContainer">
          <Loading/>
        </div>
      ) : (
        <div>

          <div className="mainFormBoxContainer">
            <div className="formBoxContainer">
              
              <div className="styledInputText">Introduzca su correo electrónico</div>
              <StyledInput type="email" size="auto" value={mailToValidate} onChange={(e)=> setMailToValidate(e.target.value)} className="mailToValidateInput"
                onKeyDown={(e) => {
                  if (e.key === "Enter" && mailToValidate && captchaValue && !loading) {
                    validate();
                  }
                }}
              />
              
              <div className="formContainer">
                <ReCAPTCHA hl="es" ref={recaptcha}
                  onChange={(value) => setCaptchaValue(value)}
                  onErrored={() => {
                    console.warn("reCAPTCHA falló al cargar o ejecutar.");
                    setCaptchaValue(null);
                  }}
                  onError={(err) => {
                    console.warn("Error en reCAPTCHA:", err);
                    setCaptchaValue(null);
                  }}
                  onExpired={() => {
                    console.info("reCAPTCHA expiró.");
                    setCaptchaValue(null);
                  }}
                sitekey={process.env.REACT_APP_SITE_KEY} />
                <StyledButton className="validateButton" disabled={loading || !captchaValue || !mailToValidate} onClick={() => validate()}>Validar</StyledButton>
              </div>

            </div>
          </div>
          {openSnackbar ? (
              <Snackbar snackbarText={snackbarText} setOpenSnackbar={setOpenSnackbar}></Snackbar>
            ) : (<></>)
          }
        </div>
      )}
    </div>
  )
};

export default ValidateData